import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * 统一处理好作为无界子应用相关的处理
 */
export const useRunAsWujieSubApp = () => {
  const wujie = (window as any).$wujie;
  const isSubApp = Boolean(wujie);
  /** 路由变化通知基座更新url */
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!isSubApp) {
      return;
    }
    wujie.bus.$emit('routeChange', {
      path: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search]);

  // 基座的非子应用路由更新，更新子应用
  useEffect(() => {
    if (!isSubApp) {
      return;
    }
    const onRouteChange = (route: string) => {
      if (route === location.pathname + location.search) return;
      // console.log(
      //   '【子应用】【更新路由】',
      //   route,
      //   location.pathname + location.search
      // );
      navigate(route, { replace: true });
    };
    wujie.bus.$on('routeChange', onRouteChange);
    return () => {
      wujie.bus.$off('routeChange', onRouteChange);
    };
  }, [navigate, location]);
};

export const useWujieMethods = () => {
  const wujie = (window as any).$wujie;
  const handleOpenConnectModal = () => {
    wujie?.bus.$emit('showConnectWallet');
  };
  const handleLogin = () => {
    wujie?.bus.$emit('login');
  };
  const handleCreateWallet = () => {
    wujie?.bus.$emit('createWallet');
  };
  /** 切换钱包 */
  const handleSwitchWallet = () => {
    wujie?.bus.$emit('switchWallet');
  };
  /** 切换链 */
  const handleSwitchChain = (id: number) => {
    try {
      wujie?.bus.$emit('switchChain', id);
    } catch (error) {
      console.log(error);
    }
  };
  /** 充值 */
  const handleDeposit = (
    chainCode = 'BTC',
    token = 'BTC',
    address = '',
    depositChainData?: any
  ) => {
    wujie.bus.$emit('deposit', {
      chainCode,
      token,
      address,
      depositChainData,
    });
  };

  // 断开三方钱包
  const handleDisconnectThird = () => {
    wujie?.bus.$emit('disconnectThird');
  };

  //
  const handleConnectBybitWallet = (
    walletType: number[],
    chainType: number
  ) => {
    wujie?.bus.$emit('connectBybitWallet', walletType, chainType);
  };

  return {
    handleLogin,
    handleOpenConnectModal,
    handleCreateWallet,
    handleSwitchWallet,
    handleSwitchChain,
    handleDeposit,
    handleDisconnectThird,
    handleConnectBybitWallet,
    wujie,
  };
};

const applicationDelay = new Promise<void>((resolve) => {
  setTimeout(resolve, 1000);
});

/**
 * 获取当前钱包
 * @returns
 */
export const useCurrentWalletInfo = () => {
  const [wallet, setWallet] = useState<any>(null);
  const wujie = (window as any).$wujie;

  /** 获取当前钱包信息 */
  const getCurrentWalletInfo = (): Array<{
    address: string;
    chainType: number;
    userId: number;
  }> => {
    const walletInfo = wujie?.bus.$emit('getCurrentWalletInfo') ?? [];
    return walletInfo;
  };

  useEffect(() => {
    wujie?.bus.$on(
      'currentWallet',
      (data: Array<{ address: string; chainType: number; userId: number }>) => {
        console.log('wujie hook currentWallet', data);
        setWallet(data);
      }
    );
    // 等1s再获取钱包信息，防止获取不到
    applicationDelay.then(() => wujie?.bus.$emit('getCurrentWalletInfo'));
  }, []);

  return {
    wallet,
    getCurrentWalletInfo,
  };
};
